import { useEffect, useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { ChannelPicker, CHANNEL_TYPE } from '@/components/ChannelPicker';
import { useConfigPage, BackLink } from './_shared';

export function TempChannelsConfig() {
  const { guildId, settingsQuery, saveMut, currentConfig } = useConfigPage('tempChannels');
  const [categoryId, setCategoryId] = useState<string | null>(null);
  const [joinToCreateId, setJoinToCreateId] = useState<string | null>(null);

  useEffect(() => {
    if (settingsQuery.data) {
      setCategoryId((currentConfig.categoryId as string) ?? null);
      setJoinToCreateId((currentConfig.joinToCreateId as string) ?? null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settingsQuery.data]);

  if (settingsQuery.isLoading) return <p className="text-muted-foreground">Lade…</p>;

  return (
    <div className="mx-auto max-w-2xl">
      <BackLink guildId={guildId} />
      <h1 className="mb-6 text-2xl font-semibold">Temp-Channels — Konfiguration</h1>

      <Card>
        <CardHeader>
          <CardTitle className="text-lg">Join-to-Create Voice</CardTitle>
          <CardDescription>
            Kategorie und Voice-Channel für dynamische Temp-Voice-Räume.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div>
            <Label>Kategorie (für neue Temp-Voice-Channels)</Label>
            <ChannelPicker
              guildId={guildId}
              value={categoryId}
              onChange={setCategoryId}
              types={[CHANNEL_TYPE.GUILD_CATEGORY]}
              placeholder="— Kategorie wählen —"
            />
          </div>
          <div>
            <Label>Join-to-Create Voice-Channel</Label>
            <ChannelPicker
              guildId={guildId}
              value={joinToCreateId}
              onChange={setJoinToCreateId}
              types={[CHANNEL_TYPE.GUILD_VOICE]}
            />
            <p className="mt-1 text-xs text-muted-foreground">
              Wenn ein User diesen Channel joint, erstellt der Bot einen persönlichen
              Voice-Raum in der Kategorie oben.
            </p>
          </div>

          <div className="flex items-center justify-end pt-2">
            <Button
              disabled={saveMut.isPending || (!categoryId && !joinToCreateId)}
              onClick={() =>
                saveMut.mutate({ moduleConfig: { categoryId, joinToCreateId } })
              }
            >
              {saveMut.isPending ? 'Speichere…' : 'Speichern'}
            </Button>
          </div>
          {saveMut.isSuccess && <p className="text-sm text-success">Gespeichert ✓</p>}
          {saveMut.error && (
            <p className="text-sm text-destructive">
              Fehler: {(saveMut.error as Error).message}
            </p>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
